import React from 'react';
import { ListFilterButton } from './ui/FilterButton';
import { ListSort, IOption } from './ui/Sort';
import { Search } from './ui/Search';
import { Create } from './ui/Create';
import { IListSearch } from './ui/Search';

interface IListActions<T> {
    hasFilter?: {
        title: string;
        onClick: () => void;
        selectedFilterCount: number;
    };
    hasSort?: {
        title: string;
        onClick: (sortOption: IOption) => void;
        sortOptions: IOption[];
        selectedSortOption?: IOption;
    };
    hasCreate?: {
        title: string;
        onClick: () => void;
    };
    hasSearch?: IListSearch<T>;
}
export default function ListActions<T>(props: IListActions<T>) {
    return (
        <>
            {props.hasSort && <ListSort {...props.hasSort} />}
            {props.hasCreate && <Create {...props.hasCreate} />}
            {props.hasFilter && <ListFilterButton {...props.hasFilter} />}
            {props.hasSearch && <Search {...props.hasSearch} />}
        </>
    );
}
